import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_PERIOD_LOCK } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import PeriodLock from '../../components/PeriodLock';

// Optional search params (deep-link / row-action filters); never fail validation.
const periodLockSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/period-lock/')({
  validateSearch: periodLockSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PERIOD_LOCK, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.period-lock',
        suffix: 'menu.periodLock',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: PeriodLockRoute,
});

function PeriodLockRoute() {
  return <PeriodLock />;
}
